import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  UserX,
  Users2, 
  Activity, 
  Trophy, 
  MessageSquare, 
  Crown, 
  BarChart3,
  X,
  Target
} from 'lucide-react';

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();

  const menuItems = [
    {
      title: 'Dashboard',
      icon: LayoutDashboard,
      path: '/',
    },
    {
      title: 'User Management',
      icon: Users,
      path: '/users',
    },
    {
      title: 'Inactive Users',
      icon: UserX,
      path: '/users/inactive',
    },
    {
      title: 'Group Management',
      icon: Users2,
      path: '/groups',
    },
    {
      title: 'Activities',
      icon: Activity,
      path: '/activities',
    },
    {
      title: 'Challenges & Goals',
      icon: Target,
      path: '/challenges',
    },
    {
      title: 'Hotstepper Comm',
      icon: MessageSquare,
      path: '/hotstepper',
    },
    {
      title: 'City Leaderboard',
      icon: Crown,
      path: '/leaderboard',
    },
    {
      title: 'Reports & Analytics',
      icon: BarChart3,
      path: '/reports',
    },
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:inset-y-0 lg:bg-sidebar-bg lg:border-r lg:border-gray-200">
        <div className="flex-1 flex flex-col min-h-0">
          {/* Logo */}
          <div className="flex items-center h-16 flex-shrink-0 px-4 bg-sidebar-bg border-b border-gray-700">
            <Activity className="h-8 w-8 text-blue-400" />
            <span className="ml-2 text-xl font-bold text-white">Stepping4life Admin</span>
          </div>

          {/* Navigation */}
          <nav className="mt-5 flex-1 px-2 space-y-1">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`sidebar-item ${isActive ? 'active' : ''}`}
                >
                  <Icon className="mr-3 h-5 w-5" />
                  {item.title}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div className={`lg:hidden fixed inset-y-0 left-0 z-30 w-64 bg-sidebar-bg transform ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } transition-transform duration-300 ease-in-out`}>
        <div className="flex-1 flex flex-col min-h-0">
          {/* Logo with close button */}
          <div className="flex items-center justify-between h-16 flex-shrink-0 px-4 bg-sidebar-bg border-b border-gray-700">
            <div className="flex items-center">
              <Activity className="h-8 w-8 text-blue-400" />
              <span className="ml-2 text-xl font-bold text-white">Fitness Admin</span>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-400 hover:text-white"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          {/* Navigation */}
          <nav className="mt-5 flex-1 px-2 space-y-1">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`sidebar-item ${isActive ? 'active' : ''}`}
                >
                  <Icon className="mr-3 h-5 w-5" />
                  {item.title}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar; 